export const HYPHEN = '-';
export const MINUS = '−';
export const PLUS = '+';
export const NBSP = '\u00a0';

export const MAX_FRACTIONAL_DIGITS = 20;
